<!-- Modal Header with proper icon alignment -->
<div class="modal-header">
  <h3 class="modal-title">{{f4626Header.ATTRIB_DESCRIPTION || 'Alternative Minimum Tax - Corporations'}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  
  <!-- Single Tab Navigation (Form Entry only) -->
  <ul class="nav nav-pills" role="tablist">
    <li class="active">
      <a style="cursor: pointer;" class="btn-sm">Form Entry</a>
    </li>
  </ul>

  <div class="tab-content">
    <!-- SMALL loader for form content only -->
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}
    
    @if (!showFormLoader) {
<div>
      <form name="screenFrom" id="screenFrom" class="form-horizontal" novalidate>
      
      <!-- Entity Details Table (from original AngularJS) -->
      <table style="width: 100%; border: 0px; cellspacing: 0; cellpadding: 0;">
        <tbody>
          <tr>
            <td class="LayerLine1" nowrap>Entity:</td>
            <td class="LayerData1" nowrap>{{rowData.LEID + " " + ":" + " " + rowData.LE_NAME + " " + ":" + " " + rowData.TAX_YEAR_BEGIN + " " + "-" + " " + rowData.TAX_YEAR_END}}</td>
            <td class="LayerLine1" nowrap>Business:</td>
            <td class="LayerData1" nowrap>{{rowData.ME_CODE + " " + "-" + " " + rowData.ME_NAME}}</td>
            <td class="LayerLine1" nowrap>Tax Code:</td>
            <td class="LayerData1" nowrap>{{rowData.CDR_NO}}</td>
          </tr>
        </tbody>
      </table>

      <!-- Form Header -->
      <table class="InnerTblBG" style="width: 100%; border: 0px; cellspacing: 0; cellpadding: 0; font-weight: bold;">
        <tbody>
          <tr>
            <th class="BlackSmHdrBC">
              <h4>{{f4626Header.ATTRIB_DESCRIPTION}} <span style="color: red;"> (Inc/Dec)</span></h4>
            </th>
          </tr>
          <tr>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>

      <!-- Info Section -->
      <table class="InnerTblBG" style="width: 100%; border: 0px; cellspacing: 0; cellpadding: 0">
        <tbody>
          <tr>
            <td style="width: 3px;">
              <i class="fa fa-info-circle" style="font-size:24px;color:skyblue"></i>
            </td>
            <td class="BlackTxtBL">
              {{f4626Header.ATTRIB_DESCRIPTION}} (Increase/Decrease Format)
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Main Form Table -->
      <table class="table table-bordered form-inline InnerTblBG custom-table">
        <!-- Table Header -->
        <tr>
          <th style="font-weight: bold; text-align:center;" width="55%">
            Description
          </th>
          <th style="font-weight: bold; text-align:center;" width="15%">
            Input
          </th>
          <th style="font-weight: bold; text-align:center;" width="10%">
            PSHIP K1
          </th>
          <th style="font-weight: bold; text-align:center;" width="10%">
            FACS
          </th>
          <th style="font-weight: bold; text-align:center;" width="10%">
            TOTAL
          </th>
        </tr>
        
        <!-- Loop for whole data -->
        @for (row of f4626FormData; track $index; let mainIndex = $index) {

          
          <!-- Page Header rows (PH) -->
          @if (row.ROW_TYPE === 'PH') {
<tr>
            <td style="font-weight: bold; text-align:center;" colspan="5">
              <h5 style="font-weight: bold;">{{row.Line_data[0].ATTRIB_VALUE}}</h5>
            </td>
          </tr>
}

          <!-- Note rows (NT) -->
          @if (row.ROW_TYPE === 'NT') {
<tr>
            @for (item of row.Line_data; track $index) {
<td [attr.align]="item.COL_CLASS" style="font-weight: bold;">
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string') {
<p>{{item.ATTRIB_VALUE}}</p>
}
            </td>
}
          </tr>
}

          <!-- Nested Note rows (NNT) -->
          @if (row.ROW_TYPE === 'NNT') {
<tr>
            @for (item of row.Line_data; track $index) {
<td [attr.align]="item.COL_CLASS" style="font-weight: bold;">
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string') {
<p> &nbsp; &nbsp; &nbsp; {{item.ATTRIB_VALUE}}</p>
}
            </td>
}
          </tr>
}

          <!-- Line Text rows (LT) -->
          @if (row.ROW_TYPE === 'LT') {
<tr>
            @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td [attr.colspan]="item.COLSPAN">
              <!-- Currency input fields -->
              @if (item.EDIT_TYPE === 'currency' && item.DATA_TYPE === 'number') {
<p style="text-align:center;">
                <input [(ngModel)]="item.ATTRIB_VALUE" 
                       class="form-control input-md numText number-field" 
                       name="field_{{mainIndex}}_{{itemIndex}}"
                       type="text"
                       onlyIntegersWithLength
                       (blur)="updateAmount(mainIndex, item.LINE_NO)" 
                       (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)" 
                       [disabled]="item.IS_EDITABLE === 'N'">
              </p>
}
              
              <!-- Label for number fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'number') {
<p style="text-align:center;">
                {{item.ATTRIB_VALUE | numberWithCommas}}
              </p>
}
              
              <!-- Label for string fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string') {
<p style="font-weight: bold;">{{item.ATTRIB_VALUE}}</p>
}
            </td>
}
          </tr>
}

          <!-- Table Header rows (TH) -->
          @if (row.ROW_TYPE === 'TH') {
<tr>
            @for (item of row.Line_data; track $index) {
<td colspan="4">
              <!-- Label for number fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'number') {
<p style="text-align:center;">
                {{item.ATTRIB_VALUE | numberWithCommas}}
              </p>
}
              
              <!-- Label for string fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string') {
<p>{{item.ATTRIB_VALUE}}</p>
}
            </td>
}
          </tr>
}

          <!-- Total Table Header rows (TTH) -->
          @if (row.ROW_TYPE === 'TTH') {
<tr>
            @for (item of row.Line_data; track $index) {
<td colspan="4">
              <!-- Label for number fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'number') {
<p style="text-align:center;">
                {{item.ATTRIB_VALUE | numberWithCommas}}
              </p>
}
              
              <!-- Label for string fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string') {
<p> &nbsp; &nbsp; &nbsp; {{item.ATTRIB_VALUE}}</p>
}
            </td>
}
          </tr>
}

          <!-- Data Detail rows (DD) -->
          @if (row.ROW_TYPE === 'DD') {
<tr>
            @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td [attr.colspan]="item.COLSPAN">
              <!-- Currency input fields -->
              @if (item.EDIT_TYPE === 'currency' && item.DATA_TYPE === 'number') {
<p style="text-align:center;">
                <input [(ngModel)]="item.ATTRIB_VALUE" 
                       class="form-control input-md numText number-field" 
                       name="field_{{mainIndex}}_{{itemIndex}}"
                       type="text"
                       onlyIntegersWithLength
                       (blur)="updateAmount(mainIndex, item.LINE_NO)" 
                       (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)" 
                       [disabled]="item.IS_EDITABLE === 'N'">
              </p>
}
              
              <!-- Label for number fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'number') {
<p style="text-align:center;">
                {{item.ATTRIB_VALUE | numberWithCommas}}
              </p>
}
              
              <!-- Label for string fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string') {
<p>{{item.ATTRIB_VALUE}}</p>
}
            </td>
}
          </tr>
}

          <!-- Data rows (DT) -->
          @if (row.ROW_TYPE === 'DT') {
<tr>
            @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td [attr.colspan]="item.COLSPAN">
              <!-- Currency input fields -->
              @if (item.EDIT_TYPE === 'currency' && item.DATA_TYPE === 'number') {
<p style="text-align:center;">
                <input [(ngModel)]="item.ATTRIB_VALUE" 
                       class="form-control input-md numText number-field" 
                       name="field_{{mainIndex}}_{{itemIndex}}"
                       type="text"
                       onlyIntegersWithLength
                       (blur)="updateAmount(mainIndex, item.LINE_NO)" 
                       (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)" 
                       [disabled]="item.IS_EDITABLE === 'N'">
              </p>
}
              
              <!-- Label for number fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'number') {
<p style="text-align:center;">
                {{item.ATTRIB_VALUE | numberWithCommas}}
              </p>
}
              
              <!-- Label for string fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string') {
<p> &nbsp; &nbsp; &nbsp; {{item.ATTRIB_VALUE}}</p>
}
            </td>
}
          </tr>
}

          <!-- Line Header rows (LH) -->
          @if (row.ROW_TYPE === 'LH') {
<tr>
            @for (item of row.Line_data; track $index; let itemIndex = $index) {
<td [attr.colspan]="item.COLSPAN">
              <!-- Currency input fields -->
              @if (item.EDIT_TYPE === 'currency' && item.DATA_TYPE === 'number') {
<p style="text-align:center;">
                <input [(ngModel)]="item.ATTRIB_VALUE" 
                       class="form-control input-md numText number-field" 
                       name="field_{{mainIndex}}_{{itemIndex}}"
                       type="text"
                       onlyIntegersWithLength
                       (blur)="updateAmount(mainIndex, item.LINE_NO)" 
                       (ngModelChange)="valuechanged(mainIndex, null, item.LINE_NO, itemIndex)" 
                       [disabled]="item.IS_EDITABLE === 'N'">
              </p>
}
              
              <!-- Label for number fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'number') {
<p style="text-align:center;">
                {{item.ATTRIB_VALUE | numberWithCommas}}
              </p>
}
              
              <!-- Label for string fields -->
              @if (item.EDIT_TYPE === 'label' && item.DATA_TYPE === 'string') {
<p> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {{item.ATTRIB_VALUE}}</p>
}
            </td>
}
          </tr>
}
          
        
}
      </table>
      
    </form>
    </div>
}
  </div>
  <!-- End of tab-content -->
</div>
<!-- End of modal-body -->

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>

